module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = ../../../../../src/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module chunks = styles